import React from "react";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "../CSS/Footer.css";
// IMPORT YOUR LOGO HERE
import logo from "../Assets/logo.png"; 

export default function Footer() {
  return (
    <footer className="pf-footer">
      <div className="pf-container">
        {/* Brand Column */}
        <div className="pf-column pf-brand-col">
          <Link to="/" className="pf-footer-logo-link">
            <img src={logo} alt="Passport Port Logo" className="pf-footer-logo" />
          </Link>
          <p className="pf-tagline">Adv. Neeraj Pandey</p>
          <p className="pf-description">
            Trusted apostille, attestation and
            legalization services across India. Fast processing · Legal guidance
            · Nationwide pickup.
          </p>
        </div>

        {/* Quick Links Column */}
        <div className="pf-column">
          <h3 className="pf-column-title">Quick Links</h3>
          <ul className="pf-list">
            <li><Link to="/apostille">Apostille</Link></li>
            <li><Link to="/faq">FAQs</Link></li>
            {/* <li><Link to="/mea-approved-university-list">MEA approved list of university</Link></li> */}
          </ul>
        </div>

        {/* Services Column */}
        <div className="pf-column">
          <h3 className="pf-column-title">Services</h3>
          <ul className="pf-list">
            <li><Link to="/services">All Services</Link></li>
            <li><Link to="/services/personal">Personal Document Apostille</Link></li>
            <li><Link to="/services/commercial">Commercial Document Apostille</Link></li>
            <li><Link to="/services/apostillemumbai">Apostille Service in Mumbai</Link></li>
            <li><Link to="/services/document-translation">Document Translation</Link></li>
            <li><Link to="/services/visa-services">Visa & FRRO Services</Link></li>
          </ul>
        </div>


        {/* Contact Column - Now contains Email and Location */}
<div className="pf-column">
  <h3 className="pf-column-title">Contact Us</h3>
  
  {/* Phone */}
  <div className="pf-contact-item">
    <FaPhoneAlt className="pf-icon" />
    <div>
      <strong>Head Office</strong>
      <a href="tel:+916393244687">+91-6393244687</a>
    </div>
  </div>

  {/* Email */}
  <div className="pf-contact-item">
    <FaEnvelope className="pf-icon" />
    <div>
      <strong>Support</strong>
      <a href="mailto:info@apostilleserviceinmumbai.com">info@apostilleserviceinmumbai.com</a>
    </div>
  </div>

  {/* Location - Using Map Icon and specific address styling */}
  <div className="pf-contact-item">
    <FaMapMarkerAlt className="pf-icon" />
    <div>
      <strong>Location</strong>
      <a 
        href="https://maps.app.goo.gl/JQAytMq72XRwCjib8" 
        target="_blank" 
        rel="noreferrer"
        className="pf-location-link"
      >
        Room Number 18, 2nd Floor, Vishwakarma Bhavan, Saibaba Road, 
        Khar East, Mumbai 400051
      </a>
    </div>
  </div>
</div>


      </div>

      {/* Bottom Bar */}
      <div className="pf-bottom">
        <p>© {new Date().getFullYear()} Authorized Apostille & Attestation. All rights reserved.</p>
      </div>
    </footer>
  );
}